import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { tokenStorage } from "../services/auth/tokenStorage";
import { logOut } from "../store/loggedIn";

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useCallback(() => {
    tokenStorage.clear();
    dispatch(logOut());
    navigate("/", { replace: true });
  }, [dispatch, navigate]);
};
